import UnsubscribedFromCustomer from './UnsubscribedFromCustomer'
export default UnsubscribedFromCustomer
